import { BubbleIconColour } from '@/lib/enum/Colour';
import { IconType } from '@/lib/enum/Icon';

export type EventActionType = {
  icon: string;
  value: string;
  action: Function;
  useAsMain?: boolean;
  enabled?: boolean;
  disabled?: boolean;
  dividerTop?: boolean;
  dividerBottom?: boolean;
};

export type MenuItemType = {
  id: number | string;
  value: string;
  icon?: string;
  stat?: string | number;
  disabled?: boolean | string | number;
  hide?: boolean;
  iconRight?: string;
  dividerTop?: boolean;
  dividerBottom?: boolean;
} & ( // Must have one of action OR url
  | {
      action: Function;
    }
  | { url: string }
);

export type ActionButton = {
  colour: string;
  label: string;
  action: Function;
  loading?: boolean;
  disabled?: boolean;
  border?: boolean;
};

export type SimpleBubbleIconType = {
  icon: IconType;
  colour: string;
};

export type BubbleIconType = {
  icon: IconType;
  foregroundColour: keyof typeof BubbleIconColour;
  backgroundColour: keyof typeof BubbleIconColour;
};

export type TPageTab = {
  id: number;
  checked: boolean;
  label: string;
  action: Function;
  icon?: string | IconType;
  stat?: number | string;
};
export const ActiveTabStyleEnum = {
  Solid: 'solid',
  Underline: 'underline',
} as const;
export type ActiveTabStyleType =
  typeof ActiveTabStyleEnum[keyof typeof ActiveTabStyleEnum];

export enum AccordionBoxTogglePositionEnum {
  Top = 'top',
  Bottom = 'bottom',
}

export enum AccordionBoxHeaderColourEnum {
  White = 'white',
  Gray = 'gray',
}

export enum PositionEnum {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}
